import apolloClient from '../../utils/apollo-client';
import { getSettlement as query } from '../graphql/settlement';

export default async function (quoteId) {
  const response = await apolloClient().then((client) =>
    client.query({
      query,
      variables: { quoteId }
    })
  );
  return response.data.getSettlement;
}
